import React, { useEffect, useState } from 'react';
import AdminSideMenu from '../../components/AdminSideMenu';
import Select from 'react-select';
import api from '../../utils/axiosInstance';
import { useParams, useNavigate } from 'react-router-dom';

// Feature options
const featureOptions = [
    { value: '20 Drivers Each Day', label: '1. 20 Drivers Each Day' },
    { value: 'Advanced Dashboard', label: '2. Advanced Dashboard' },
    { value: 'Real-time Updates', label: '3. Real-time Updates' },
    { value: 'Dedicated Account Manager', label: '4. Dedicated Account Manager' },
    { value: 'Custom drivers', label: '5. Custom drivers' },
    { value: 'Custom Tools', label: '6. Custom Tools' },
    { value: 'Dedicated Support', label: '7. Dedicated Support' },
    { value: '10+ Drivers Each Day', label: '8. 10+ Drivers Each Day' },
    { value: 'Drivers Available for 30 Days', label: '9. Drivers Available for 30 Days' },
    { value: 'Drivers Available for 60 Days', label: '10. Drivers Available for 60 Days' },
    { value: '2 Logins', label: '11. 2 Logins' },
    { value: '3-5 Drivers Per Day', label: '12. 3-5 Drivers Per Day' },
];

const EditPackage = () => {
    const [form, setForm] = useState({
        name: '',
        price: '',
        duration: '',
        code: '',
        accessDetails: '',
        noOfDrivers: '',
        features: [],
    });
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const { id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        // Fetch package details for editing
        const fetchPackage = async () => {
            try {
                setLoading(true);
                const res = await api.get(`/packages/${id}`);
                const pkg = res.data;
                setForm({
                    name: pkg.name || '',
                    price: pkg.price || '',
                    duration: pkg.duration || '',
                    code: pkg.code || '',
                    accessDetails: pkg.accessDetails || '',
                    noOfDrivers: pkg.noOfDrivers || '',
                    features: Array.isArray(pkg.features) ? pkg.features : [],
                });
            } catch (err) {
                alert('Failed to load package.');
            } finally {
                setLoading(false);
            }
        };
        fetchPackage();
    }, [id]);

    const handleInput = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleFeatures = (selected) => {
        setForm((prev) => ({ ...prev, features: selected ? selected.map((opt) => opt.value) : [] }));
    };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     setSaving(true);
    //     try {
    //         await api.put(`/packages/${id}`, form);
    //         alert('Package updated!');
    //         navigate('/admin/packages');
    //     } catch (err) {
    //         alert('Error updating package');
    //     } finally {
    //         setSaving(false);
    //     }
    // };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);

        try {
            const payload = {
                name: form.name.trim(),
                code: form.code.trim(),
                price: Number(form.price),
                duration: Number(form.duration),
                accessDetails: Number(form.accessDetails),

                noOfDrivers: Number(form.noOfDrivers),

                features: Array.isArray(form.features)
                    ? form.features.filter((f) => typeof f === 'string' && f.trim())
                    : [],
            };

            await api.put(`/packages/${id}`, payload);

            alert('Package updated!');
            navigate('/admin/packages');
        } catch (err) {
            alert(err.response?.data?.message || 'Error updating package');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className='flex min-h-screen bg-gray-50'>
            <AdminSideMenu />

            <div className='w-full md:ml-64 p-4 sm:p-6 lg:p-8'>
                <div className='max-w-3xl mx-auto bg-white shadow-xl rounded-3xl p-8'>
                    <header className='mb-8'>
                        <h1 className='text-2xl font-bold text-gray-900 mb-1'>Edit Package</h1>
                        <p className='text-gray-600'>Update your subscription package below.</p>
                    </header>

                    {loading ? (
                        <div className='text-center text-gray-500 py-20 text-lg'>Loading package...</div>
                    ) : (
                        <form onSubmit={handleSubmit} className='space-y-6'>
                            <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
                                {/* Name */}
                                <div>
                                    <label className='block mb-2 font-semibold text-gray-800'>Name *</label>
                                    <input
                                        name='name'
                                        type='text'
                                        value={form.name}
                                        required
                                        onChange={handleInput}
                                        className='w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-400'
                                    />
                                </div>
                                {/* Price */}
                                <div>
                                    <label className='block mb-2 font-semibold text-gray-800'>Price ($) *</label>
                                    <input
                                        name='price'
                                        type='number'
                                        min={0}
                                        step='any'
                                        value={form.price}
                                        required
                                        onChange={handleInput}
                                        className='w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-400'
                                    />
                                </div>
                                {/* Duration */}
                                <div>
                                    <label className='block mb-2 font-semibold text-gray-800'>Duration *</label>
                                    <input
                                        name='duration'
                                        type='number'
                                        value={form.duration}
                                        required
                                        onChange={handleInput}
                                        className='w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-400'
                                    />
                                </div>
                                {/* Package Code */}
                                <div>
                                    <label className='block mb-2 font-semibold text-gray-800'>Package Code *</label>
                                    <input
                                        name='code'
                                        type='text'
                                        value={form.code}
                                        required
                                        onChange={handleInput}
                                        className='w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-400'
                                    />
                                </div>
                                {/* Access Details */}

                                <div>
                                    <label className='block mb-2 font-semibold text-gray-800'>Access Details *</label>
                                    <input
                                        name='accessDetails'
                                        type='number'
                                        value={form.accessDetails}
                                        required
                                        onChange={handleInput}
                                        className='w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-400'
                                        min={0}
                                    />
                                </div>
                                {/* NEW TAG → No of Drivers */}
                                <div>
                                    <label className='block mb-2 font-semibold text-gray-800'>No of Drivers *</label>
                                    <input
                                        type='number'
                                        name='noOfDrivers'
                                        min='1'
                                        max='12'
                                        value={form.noOfDrivers}
                                        onChange={handleInput}
                                        required
                                        className='w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-400'
                                    />
                                </div>
                            </div>

                            {/* Features */}
                            <div>
                                <label className='block mb-2 font-semibold text-gray-800'>Features *</label>
                                <Select
                                    isMulti
                                    name='features'
                                    options={featureOptions}
                                    value={featureOptions.filter((opt) => form.features.includes(opt.value))}
                                    onChange={handleFeatures}
                                    className='react-select-container'
                                    classNamePrefix='react-select'
                                    placeholder='Select features...'
                                />
                            </div>

                            <div className='pt-2 text-right'>
                                <button
                                    type='submit'
                                    className='py-3 px-8 rounded-lg font-semibold bg-blue-600 hover:bg-blue-700 text-white shadow transition'
                                    disabled={saving}
                                >
                                    {saving ? 'Saving...' : 'Update Package'}
                                </button>
                            </div>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
};

export default EditPackage;
